/**
 * How a map link (`/map?poi=water`, `/map?amenities=…`, `/map?get_user_recordings=true`) meets
 * the layers the walker has saved.
 *
 * Every layer in the Maps dialog stays on until the walker turns it off, so a link can switch
 * layers ON for this visit and onward, but never switches a saved one off: the linked layers are
 * added after the saved ones. Before this, a "View on map" link replaced the saved selection and
 * saved over it, silently dropping every other overlay and POI the walker had on.
 *
 * Same rule as the apps' deep links — Android `savePOIsFromArgs`, iOS
 * `PoiSelectionSession.enableTypes(fromDeepLink:)`.
 */

/** The saved selection followed by any linked entry it doesn't have yet, each once. */
export function mergeLinkedSelection(saved: readonly string[], linked: readonly string[]): string[] {
  const merged: string[] = [];
  for (const entry of [...saved, ...linked]) {
    if (!merged.includes(entry)) merged.push(entry);
  }
  return merged;
}

/**
 * The walker's own-hike overlays a link switches on: every known source named `=true` in
 * [search]. A `=false` (or any other value) switches nothing off.
 */
export function linkedTrailSources(search: string, validSources: readonly string[]): string[] {
  const params = new URLSearchParams(search);
  return validSources.filter((src) => params.get(src) === 'true');
}
